import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=c97a4288&scoped=true"
import script from "./CarManage.vue?vue&type=script&lang=js"
export * from "./CarManage.vue?vue&type=script&lang=js"
import style0 from "./CarManage.vue?vue&type=style&index=0&id=c97a4288&prod&scoped=true&lang=scss"
import style1 from "./CarManage.vue?vue&type=style&index=1&id=c97a4288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a4288",
  null
  
)

export default component.exports